export { default } from "./CreateNewClassroomModal";
